import { render, staticRenderFns } from "./TeacherDetailModal.vue?vue&type=template&id=3c3ae225&scoped=true"
import script from "./TeacherDetailModal.vue?vue&type=script&lang=js"
export * from "./TeacherDetailModal.vue?vue&type=script&lang=js"
import style0 from "./TeacherDetailModal.vue?vue&type=style&index=0&id=3c3ae225&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ae225",
  null
  
)

export default component.exports